// Helpers
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'

export const CheckEligibilities = {
  created() {
    if (this.role === 'candidate') this.fetchEligibilities()
  },

  computed: {
    ...mapState('candidate/eligibilities', {
      eligibilities: 'all',
      loadingEligibilities: 'loading',
    }),

    ...mapGetters({ role: 'auth/role' }),

    eligibility() {
      return this.$store.getters['candidate/eligibilities/forOpportunity'](this.opportunity.id)
    },
  },

  methods: {
    waitForLoadingEligibilities() {
      return new Promise(resolve => this.checkLoadEligibilities(resolve))
    },

    checkLoadEligibilities(resolve, stack = 0) {
      if (!this.loadingEligibilities || stack > 50) {
        resolve()
        return
      }

      setTimeout(() => this.checkLoadEligibilities(resolve, stack + 1), 200)
    },

    fetchEligibilities() {
      if (!_.get(this, 'eligibilities[0]') && !this.loadingEligibilities) {
        this.$store.dispatch('candidate/eligibilities/fetchAll').then(() => {})
      }

      this.waitForLoadingEligibilities().then(() => {
        if (this.opportunity && typeof _.get(this, 'eligibility.eligible') !== 'boolean') {
          this.loading = true
          this.$store
            .dispatch('candidate/eligibilities/checkEligibility', this.opportunity)
            .then(() => (this.loading = false))
        }
      })
    },
  },
}

export default { CheckEligibilities }
